import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragHandleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 9H7M11 5H7M11 13H7",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDragHandleIcon;
